import { Tooltip, Text } from '@lounge-fe/ui-kit'
import { Icon } from '@lounge-fe/ui-kit'
import type { DiscountProgressProps } from './types'

export const InfoTooltip: React.FC<
  Pick<DiscountProgressProps, 'infoTooltip'>
> = ({ infoTooltip }) => {
  if (!infoTooltip) return null
  const { title, body } = infoTooltip

  return (
    <Tooltip position="bottom">
      <Tooltip.Trigger>
        <Icon.Information className="w-5 h-5" />
      </Tooltip.Trigger>
      <Tooltip.Content className="min-w-[164px] md:min-w-[276px]">
        {title && <Text variant="title-six">{title}</Text>}
        <div
          className="mt-1 text-subtle"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </Tooltip.Content>
    </Tooltip>
  )
}
